<script>
import appConfig from "@/app.config";
import {pagingModel} from "@/models/pagingModel";
import {userModel} from "@/models/userModel";
import {CONSTANTS} from "@/helpers/constants";
import Multiselect from "vue-multiselect";
import {notifyModel} from "@/models/notifyModel";
import {hopThuModel} from "@/models/hopThuModel";

export default {
  page: {
    title: "Quản trị hộp thư",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      url: process.env.VUE_APP_API_URL + "files/view/",
      title: "Quản trị hộp thư",
      data: [],
      currentPage: 1,
      perPage: 20,
      pageOptions: [20, 50, 80, 100],
      showModal: false,
      showDeleteModal: false,
      showUpdateModal: false,
      submitted: false,
      sortBy: "age",
      isBusy: false,
      filter: null,
      sortDesc: false,
      filterOn: [],
      todoFilter: null,
      todofilterOn: [],
      numberOfElement: 1,
      totalRows: 1,
      model: hopThuModel.baseJson(),
      modelUser: userModel.baseJson(),
      pagination: pagingModel.baseJson(),
      showChiTietChuaXem: false,
      fields: [
        {
          key: 'STT',
          label: 'STT',
          thStyle: {width: '50px', minWidth: '50px'},
          class: "text-center",
          thClass: 'hidden-sortable text-primary bold',
        },
        {
          key: "title",
          label: "Tiêu đề",
          class: "",
          sortable: true,
          thClass: 'hidden-sortable text-primary bold',
        },
        {
          key: "createdBy",
          label: "Người tạo",
          thStyle: {width: '250px', minWidth: '150px'},
          class: "cs-text-center cs-show-col",
          thClass: 'hidden-sortable text-primary bold ',
        },
        {
          key: "createdAtShow",
          label: "Ngày tạo",
          thStyle: {width: '150px', minWidth: '150px'},
          class: "cs-text-center cs-show-col",
          thClass: 'hidden-sortable text-primary bold cs-text-center',
        },
        {
          key: 'process',
          label: '',
          thStyle: {width: '80px', minWidth: '80px'},
          class: " text-center btn-process ",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        }
      ],
      optionsUser: [],
      apiUrl: process.env.VUE_APP_API_URL,
      itemFilter: {
        ngayBatDauTao: null,
        ngayKetThucTao: null,
        ngayBatDauHetHan: null,
        ngayKetThucHetHan: null,
        nguoiTao: null,
        trangThai: null,
        trangThaiXem: null,
        maTraCuu: null,
        tuKhoa: null,
      },
      showModalFile: false,
    };
  },
  validations: {},
  created() {
    this.$refs.tblList?.refresh();
    this.getUser();
  },
  watch: {
    currentPage: {
      deep: true,
      handler(val) {
        this.currentPage = val;
      }
    },
    itemFilter: {
      deep: true,
      handler(val) {
        this.$refs.tblList?.refresh()
      }
    },
  },
  computed: {
    files() {
      if (this.model && this.model.files && this.model.files.length > 0) {
        var arrayFiles = this.model.files[this.model.files.length - 1];
        return [arrayFiles];
      }
      return []
    },
  },
  methods: {
    handleShowCapNhat(item){
      this.model = Object.assign({},  item);
      this.showUpdateModal = true;
    },
    handleShowDelete(item){
      this.model = item;
      this.showDeleteModal = true;
    },
    async handleUpdate(){
      await this.$store.dispatch("mailStore/updateAllMail", this.model).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.showUpdateModal = false;
          this.$refs.tblList.refresh();
        }
        this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
      })
    },
    async handleDelete(){
      await this.$store.dispatch("mailStore/deleteAllMail", this.model.id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.showDeleteModal = false;
          this.$refs.tblList.refresh();
        }
        this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
      })
    },

    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.itemFilter.content,
        nguoiTao: this.itemFilter.nguoiTao,
        trangThaiXem: this.itemFilter.trangThaiXem,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      }
      this.loading = true
      try {
        let promise = this.$store.dispatch("mailStore/getPagingMainMail", params)
        return promise.then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            let data = resp.data;
            this.totalRows = data.totalRows
            let items = data.data
            console.log("items====", items)
            this.numberOfElement = items.length
            this.loading = false
            return items || []
          } else {
            return [];
          }
        })
      } finally {
        this.loading = false
      }
    },

    async handleDetail(id) {
      await this.$store.dispatch("notificationStore/getById", id).then((res) => {
        this.model = res;
        this.showModal = true;
      });
    },
    async hanldeShowFiles(id){
      await this.$store.dispatch("notificationStore/getById", id).then((res) => {
        this.model = res;
        this.showModalFile = true;
      });
    },
    async getUser() {
      try {
        await this.$store.dispatch("userStore/getAll").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsUser = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    handleShowFile(id) {
      let route = this.$router.resolve({path: '/xem-tep-tin/' + id});
      window.open(route.href, '_blank');
    },
    clearSearch() {
      this.itemFilter.ngayBatDauTao = null;
      this.itemFilter.ngayKetThucTao = null;
      this.itemFilter.ngayBatDauHetHan = null;
      this.itemFilter.ngayKetThucHetHan = null;
      this.itemFilter.nguoiTao = null;
      this.itemFilter.trangThai = null;
      this.itemFilter.trangThaiXem = null;
      this.itemFilter.maTraCuu = null;
      this.itemFilter.tuKhoa = null;
    },
    rowClass(item) {
      console.log("item8e728", item.read);
      // if (item.read === false) return "cs-table-read"
      return "";
    },
  }
};
</script>

<template>
  <div>
    <div class="row p-2">
      <div class="col-12">
        <div>
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 mb-4">
                  <div class="row">
                    <div class="col-md-4 col-12 d-flex align-items-center">
                      <h4 class="font-size-18 fw-bold text-dark"> {{ title }}</h4>
                    </div>
                    <div class="col-md-8 col-12 text-end">
                      <b-button v-b-toggle.collapseSearch variant="light"
                                class="btn w-md btn-primary-outline me-2" size="sm">
                        <i class="fas fa-caret-down align-middle me-2"></i>
                        Tìm kiếm
                      </b-button>
                    </div>
                  </div>
                  <b-collapse id="collapseSearch" class="mt-1">
                    <div class="row">
                      <div class="col-12">
                        <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
                          <!-- Ngày tạo -->
                          <!-- <div class="flex-grow-1 me-2">
                            <label class="mb-1">Ngày tạo</label>
                            <div class="d-flex justify-content-between align-items-center flex-wrap">
                              <div class="flex-grow-1 me-2 mb-md-0 mb-2">
                                <date-picker v-model="itemFilter.ngayBatDauTao"
                                             format="DD/MM/YYYY"
                                             value-type="format"
                                >
                                  <div slot="input">
                                    <input v-model="itemFilter.ngayBatDauTao"
                                           v-mask="'##/##/####'" type="text" class="form-control"
                                           placeholder="Nhập ngày bắt đầu"/>
                                  </div>
                                </date-picker>
                              </div>
                              <div class="flex-grow-1 me-2 mb-md-0 mb-2">
                                <date-picker v-model="itemFilter.ngayKetThucTao"
                                             format="DD/MM/YYYY"
                                             value-type="format"
                                >
                                  <div slot="input">
                                    <input v-model="itemFilter.ngayKetThucTao"
                                           v-mask="'##/##/####'" type="text" class="form-control"
                                           placeholder="Nhập ngày kết thúc"/>
                                  </div>
                                </date-picker>
                              </div>
                            </div>
                          </div> -->
                          <!--Ngày hết hạn -->
                          <!-- <div class="flex-grow-1 me-2">
                            <label class="mb-1">Ngày ký</label>
                            <div class="d-flex justify-content-between align-items-center flex-wrap">
                              <div class="flex-grow-1 me-2 mb-md-0 mb-2">
                                <date-picker v-model="itemFilter.ngayBatDauHetHan"
                                             format="DD/MM/YYYY"
                                             value-type="format"
                                >
                                  <div slot="input">
                                    <input v-model="itemFilter.ngayBatDauHetHan"
                                           v-mask="'##/##/####'" type="text" class="form-control"
                                           placeholder="Nhập ngày bắt đầu"/>
                                  </div>
                                </date-picker>
                              </div>
                              <div class="flex-grow-1 me-2 mb-md-0 mb-2">
                                <date-picker v-model="itemFilter.ngayKetThucHetHan"
                                             format="DD/MM/YYYY"
                                             value-type="format"
                                >
                                  <div slot="input">
                                    <input v-model="itemFilter.ngayKetThucHetHan"
                                           v-mask="'##/##/####'" type="text" class="form-control"
                                           placeholder="Nhập ngày kết thúc"/>
                                  </div>
                                </date-picker>
                              </div>
                            </div>
                          </div> -->
                          <!-- Người tạo -->
                          <!-- <div class="flex-grow-1 me-2">
                            <label class="mb-1">Người tạo</label>
                            <multiselect v-model="itemFilter.nguoiTao" :options="optionsUser" track-by="id" label="ten"
                                         placeholder="Chọn người tạo" deselect-label="Nhấn để xoá"
                                         selectLabel="Nhấn enter để chọn"
                                         selectedLabel="Đã chọn"></multiselect>
                          </div> -->
                        </div>
                        <div class="d-flex justify-content-around align-items-end flex-wrap">
                          <!-- Trạng thái -->
                          <!-- <div class="flex-grow-1 me-2">
                            <label class="mb-1">Trạng thái</label>
                            <multiselect v-model="itemFilter.trangThai" :options="optionsUser" track-by="id" label="ten"
                                         placeholder="Chọn trạng thái" deselect-label="Nhấn để xoá"
                                         selectLabel="Nhấn enter để chọn"
                                         selectedLabel="Đã chọn"></multiselect>
                          </div> -->
                          <!-- Trạng thái xem -->

                          <!-- Mã tra cứu -->
                          <!-- <div class="flex-grow-1 me-2">
                            <label class="mb-1">Mã tra cứu</label>
                            <input size="sm" type="text" name="untyped-input" class="form-control"
                                   v-model="itemFilter.maTraCuu"
                                   placeholder="Mã tra cứu"/>
                          </div> -->
                          <!-- Từ khoá -->
                          <div class="flex-grow-1 me-2">
                            <label class="mb-1">Từ khoá</label>
                            <input size="sm" type="text" name="untyped-input" class="form-control"
                                   v-model="itemFilter.content"
                                   placeholder="Từ khoá"/>
                          </div>
                          <div class="flex-grow-1 me-2">
                            <label class="mb-1">Người tạo</label>
                            <multiselect v-model="itemFilter.nguoiTao" :options="optionsUser" track-by="id" label="fullName"
                                         placeholder="Chọn người tạo" deselect-label="Nhấn để xoá"
                                         selectLabel="Nhấn enter để chọn"
                                         selectedLabel="Đã chọn">

                              <template slot="singleLabel" slot-scope="{ option }">
                                <strong>{{ option.fullName }}</strong>

                                <span v-if="option.donVi" style="color:red">&nbsp;{{ option.donVi.ten }}</span>
                              </template>
                              <template slot="option" slot-scope="{ option }">
                                <div class="option__desc">
          <span class="option__title">
            <strong>{{ option.fullName }}&nbsp;</strong>
          </span>
                                  <span v-if="option.donVi" class="option__small"
                                        style="color:green">{{ option.donVi.ten }}</span>
                                </div>
                              </template>

                            </multiselect>
                          </div>
                          <!--  Xử lý -->
                          <div class="flex-grow-0 ms-2">
                            <div class="d-flex justify-content-between align-items-center flex-wrap">
                              <!--                        <div class="flex-grow-1 mt-xl-0 mt-2">-->
                              <!--                          <b-button @click="handleSearch" variant="light"-->
                              <!--                                    class="btn w-md btn-primary me-2" size="md">-->
                              <!--                            <i class="fas fa-search align-middle me-2"></i>-->
                              <!--                            Tìm kiếm-->
                              <!--                          </b-button>-->
                              <!--                        </div>-->
                              <!--                        <div class="flex-grow-1 mt-xl-0 mt-2">-->
                              <!--                          <b-button @click="clearSearch" variant="light"-->
                              <!--                                    class="btn w-md btn-secondary me-2" size="md">-->
                              <!--                            <i class="fas fa-redo-alt align-middle me-2"></i>-->
                              <!--                            Làm mới-->
                              <!--                          </b-button>-->
                              <!--                        </div>-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="row">
                    <div class="col-12">
                      <!-- Table -->
                      <div class="table-responsive-sm">
                        <b-table
                            class="datatables"
                            :items="myProvider"
                            :fields="fields"
                            bordered
                            responsive="sm"
                            :per-page="perPage"
                            :current-page="currentPage"
                            :sort-by.sync="sortBy"
                            :sort-desc.sync="sortDesc"
                            :filter="filter"
                            :filter-included-fields="filterOn"
                            ref="tblList"
                            primary-key="id"
                            :busy.sync="isBusy"
                        >
                          <template v-slot:cell(STT)="data">
                            <p class="fw-bold font-size-15" >
                              {{ data.index + ((currentPage - 1) * perPage) + 1 }}</p>
                          </template>
                          <template v-slot:cell(title)="data">
                            <div
                                style="cursor: pointer"
                            >
                              <strong class="font-size-15" v-html="data.item.title" v-if="!data.item.read"></strong>
                              <div v-html="data.item.title" v-else> {{ data.item.title }}</div>
                            </div>
                          </template>

                          <template v-slot:cell(process)="data">
                            <b-dropdown
                                id="dropdown-right"
                                right
                                variant="outline"
                                class="cs-btn-dropdown"
                                menu-class="dropdown-menu-end"
                            >
                              <template v-slot:button-content>
                                ...
                              </template>
                              <b-dropdown-item
                                  v-on:click="handleShowCapNhat(data.item)"
                              >
                                <button
                                    type="button" size="sm" class="btn btn-edit btn-sm" data-toggle="tooltip"
                                    data-placement="bottom" title="Cập nhật"
                                >
                                  <i class="fas fa-pencil-alt"></i>
                                </button>
                                <span class="ms-2"> Cập nhật</span>
                              </b-dropdown-item>
                              <b-dropdown-item
                                  v-on:click="handleShowDelete(data.item)"
                              >
                                <button
                                    type="button" size="sm" class="btn btn-delete btn-sm" data-toggle="tooltip"
                                    data-placement="bottom" title="Xóa">
                                  <i class="fas fa-trash-alt"></i>
                                </button>
                                <span class="ms-2">Xóa</span>
                              </b-dropdown-item>
                            </b-dropdown>
                          </template>
                        </b-table>
                        <template v-if="isBusy">
                          <div align="center">Đang tải dữ liệu</div>
                        </template>
                        <template v-if="totalRows <= 0 && !isBusy">
                          <div align="center">Không có dữ liệu</div>
                        </template>
                      </div>
                      <!-- Paginnation -->
                      <div>
                        <div class="row mb-2">
                          <div class="col-sm-12 col-md-6">
                            <div style="display: flex; justify-content: start; align-items: center">
                              <div style="margin-right: 20px" class="">
                                <div id="tickets-table_length" class="dataTables_length">
                                  <label class="d-inline-flex align-items-center">
                                    Hiện
                                    <b-form-select
                                        class="form-select form-select-sm"
                                        v-model="perPage"
                                        size="sm"
                                        :options="pageOptions"
                                    ></b-form-select
                                    >&nbsp;dòng
                                  </label>
                                </div>

                              </div>
                              <div class="">
                                <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-sm-12 col-md-6">
                            <div
                                class="dataTables_paginate paging_simple_numbers float-end">
                              <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                ></b-pagination>
                              </ul>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--        Modal delete -->
          <b-modal v-model="showDeleteModal" centered title="Xóa dữ liệu" title-class="fw-bold fs-5 text-dark"
                   no-close-on-backdrop>
            <p>
              Dữ liệu xóa sẽ không được phục hồi!
            </p>
            <template #modal-footer>
              <b-button v-b-modal.modal-close_visit size="sm" class="btn btn-outline-info w-md"
                        v-on:click="showDeleteModal = false">
                Đóng
              </b-button>
              <b-button v-b-modal.modal-close_visit size="sm" variant="danger" type="button" class="w-md"
                        v-on:click="handleDelete">
                Xóa
              </b-button>
            </template>
          </b-modal>
          <!--        Modal Update -->
          <b-modal v-model="showUpdateModal" centered title="Cập nhật tiêu đề" title-class="fw-bold fs-5 text-dark"
                   no-close-on-backdrop>
            <div>
              <textarea class="form-control" v-model="model.title" rows="4"></textarea>
            </div>
            <template #modal-footer>
              <b-button v-b-modal.modal-close_visit size="sm" class="btn btn-outline-info w-md"
                        v-on:click="showUpdateModal = false">
                Đóng
              </b-button>
              <b-button v-b-modal.modal-close_visit size="sm" variant="danger" type="button" class="w-md"
                        v-on:click="handleUpdate">
                Cập nhật
              </b-button>
            </template>
          </b-modal>
        </div>
      </div>
    </div>
  </div>

</template>
<style>
.td-stttt {
  text-align: center;
  width: 10px;
}

.td-tb {
  text-align: left;
  width: 250px;
}

.td-content {
  text-align: center;
  width: 250px;
}

.td-nguoitao {
  text-align: center;
  width: 80px;
}

.td-trangthai {
  text-align: center;
  width: 50px;
}

.td-xuly {
  text-align: center;
  width: 50px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

.title-thongbao {
  color: #00568C;
  margin-right: 10px;

}

.icon-notify {
  top: 20%;
  animation: ring 2s infinite;
}

@keyframes ring {
  0% {
    transform: rotate(0);
  }
  1% {
    transform: rotate(30deg);
  }
  3% {
    transform: rotate(-28deg);
  }
  5% {
    transform: rotate(34deg);
  }
  7% {
    transform: rotate(-32deg);
  }
  9% {
    transform: rotate(30deg);
  }
  11% {
    transform: rotate(-28deg);
  }
  13% {
    transform: rotate(26deg);
  }
  15% {
    transform: rotate(-24deg);
  }
  17% {
    transform: rotate(22deg);
  }
  19% {
    transform: rotate(-20deg);
  }
  21% {
    transform: rotate(18deg);
  }
  23% {
    transform: rotate(-16deg);
  }
  25% {
    transform: rotate(14deg);
  }
  27% {
    transform: rotate(-12deg);
  }
  29% {
    transform: rotate(10deg);
  }
  31% {
    transform: rotate(-8deg);
  }
  33% {
    transform: rotate(6deg);
  }
  35% {
    transform: rotate(-4deg);
  }
  37% {
    transform: rotate(2deg);
  }
  39% {
    transform: rotate(-1deg);
  }
  41% {
    transform: rotate(1deg);
  }

  43% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(0);
  }
}

/*Thông báo*/

.info-box {
  background-color: #f5f5f5;
  padding: 5px;
  border-radius: 5px;
  border: 0.5px solid #f1f1f1;
  margin-bottom: 5px;
}

@media only screen and (max-width: 425px) {
  .sender-box,
  .recipient-box {
    background-color: #f5f5f5;
    border: 0.5px solid #f5f5f5;
    border-radius: 5px;
    padding: 5px;
    margin-bottom: 2px;
  }
}

</style>
<style>
@media only screen and (max-width: 768px) {
  /*
  Label the data
  */
  .table-thongbao > td:nth-of-type(1):before {
    content: "STT";
    font-weight: bold;
    color: #00568c;
  }

  .table-thongbao > td:nth-of-type(2):before {
    content: "Tiêu đề";
    font-weight: bold;
    color: #00568c;
  }

  .table-thongbao > td:nth-of-type(3):before {
    content: "Người tạo";
    font-weight: bold;
    color: #00568c;
  }

  .table-thongbao > td:nth-of-type(4):before {
    content: "Ngày tạo";
    font-weight: bold;
    color: #00568c;
  }

  .table-thongbao > td:nth-of-type(5):before {
    content: "Đã xem";
    font-weight: bold;
    color: #00568c;
  }

  .table-thongbao > td:nth-of-type(6):before {
    content: "Chưa xem";
    font-weight: bold;
    color: #00568c;
  }
}

.multiselect {
  min-height: 34px;
}

.multiselect__select {
  height: 34px;
}


</style>
